import { useCallback } from 'react';
import { useSetError } from '../../redux/modals';

// Shared onClick handler for a control whose real implementation is coming in a follow-up PR.
// Arg-less by design: callers embedded inside a clickable container should wrap in
// `(e) => { e.stopPropagation(); notImplemented(); }` at the call site rather than threading
// event plumbing through this hook.
export const useNotImplemented = (): (() => void) => {
  const setError = useSetError();
  return useCallback(() => {
    setError({
      title: 'Not yet implemented',
      message: 'This action is stubbed out for now — coming in a follow-up PR.'
    });
  }, [setError]);
};
